import { Constants } from "appConstants";
import { ApplicantData, ApplicantDocumentType, PersonTypeOptions } from "pages/NewApplication/steps/types";
import { BaseModel } from "./BaseModel";

export class Applicant extends BaseModel<ApplicantData> {
	id: string;
	applicantType: PersonTypeOptions;
	applicantAddressPostalCode: string;
	applicantAddressState: Constants.FederalUnits;
	applicantAddressCity: string;
	applicantAddressNeighbourhood: string;
	applicantAddressStreet: string;
	applicantAddressNumber: string;
	applicantAddressComplement: string;
	applicantName: string;
	applicantPhoneNumber: string;
	applicantEmail: string;
	applicantDocument: string;
	applicantDocumentType: ApplicantDocumentType;

	constructor(data: ApplicantData) {
		super(data);
		this.id = data.id ?? "";
		this.applicantType = data.applicantType;
		this.applicantAddressPostalCode = data.applicantAddressPostalCode ?? "";
		this.applicantAddressState = data.applicantAddressState ?? Constants.FederalUnits.AC;
		this.applicantAddressCity = data.applicantAddressCity ?? "";
		this.applicantAddressNeighbourhood = data.applicantAddressNeighbourhood ?? "";
		this.applicantAddressStreet = data.applicantAddressStreet ?? "";
		this.applicantAddressNumber = data.applicantAddressNumber ?? "";
		this.applicantAddressComplement = data.applicantAddressComplement ?? "";
		this.applicantName = data.applicantName ?? "";
		this.applicantPhoneNumber = data.applicantPhoneNumber ?? "";
		this.applicantEmail = data.applicantEmail ?? "";
		this.applicantDocument = data.applicantDocument ?? "";
		this.applicantDocumentType = data.applicantDocumentType ?? "";
	}

	get applicantTypeLabel() {
		switch (this.applicantType) {
			case "PJ":
				return "Pessoa Jurídica";
			case "PF":
				return "Pessoa Física";
			default:
				return "-";
		}
	}

	get isPF() {
		return this.applicantType === "PF";
	}

	get isPJ() {
		return this.applicantType === "PJ";
	}
}
